module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic-3.176ce3f3.png";